import { createContext, useContext } from 'react';

/**
 * Optional context for chart widgets to read/write Firestore-backed analytics state
 * (widgetOptions, selections) without prop drilling.
 */
export const AnalyticsStateContext = createContext(null);

export const useAnalyticsPageContext = () => useContext(AnalyticsStateContext);
